import * as React from "react"
import { cn } from "../../lib/utils"
import { balloons, textBalloons } from "balloons-js"

export const Balloons = React.forwardRef(
  ({ 
    type = "default", 
    text, 
    fontSize = 120, 
    color = "#000000", 
    className, 
    onLaunch 
  }, ref) => {
    const containerRef = React.useRef(null)
    
    const launchAnimation = React.useCallback(() => {
      if (type === "default") {
        balloons()
      } else if (type === "text" && text) {
        textBalloons([
          {
            text,
            fontSize,
            color,
          },
        ])
      }
      
      if (onLaunch) {
        onLaunch()
      }
    }, [type, text, fontSize, color, onLaunch])

    // Export the launch animation method
    React.useImperativeHandle(ref, () => ({
      launchAnimation,
      ...(containerRef.current || {})
    }), [launchAnimation])

    return <div ref={containerRef} className={cn("balloons-container", className)} />
  }
)
Balloons.displayName = "Balloons"
